import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <>
          <div className='d-flex align-items-center justify-content-center vh-100'>
            <div className='text-center'>
              <h1 className='display-1 fw-bold'>500</h1>
              <p className='fs-3'>
                {" "}
                <span className='text-danger'>Opps!</span> Ocorreu um erro.
              </p>
              <p className='lead'>
                {this.state.error && this.state.error.toString()}
              </p>

              {/* <Link to="/home" className='btn btn-primary'>  Voltar</Link> */}
              {/* <a href='/home' class='btn btn-primary'>
                Voltar
              </a> */}
            </div>
          </div>
        </>
      );
    }

    return this.props.children;
  }
}
